/**
 * Documents toaster behavior for ERP Accelerator.
 */

"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import CheckCircle from "lucide-react/dist/esm/icons/check-circle"
import XCircle from "lucide-react/dist/esm/icons/x-circle"
import Info from "lucide-react/dist/esm/icons/info"

function ToastIcon({ variant }: { variant?: string }) {
  if (variant === "success") {
    return <CheckCircle className="h-4 w-4 text-gray-900 flex-shrink-0 mt-0.5" />
  }
  if (variant === "destructive") {
    return <XCircle className="h-4 w-4 text-gray-900 flex-shrink-0 mt-0.5" />
  }
  return <Info className="h-4 w-4 text-gray-900 flex-shrink-0 mt-0.5" />
}

/**
 * Handles toaster behavior.
 */
export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <ToastIcon variant={variant} />
            <div className="grid gap-0.5 flex-1 min-w-0">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
